import React, {
  Fragment,
  useCallback,
  useContext,
  useState,
  useEffect,
} from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import useReactRouter from "use-react-router";

import AppLayout from "../../Layout/AppLayout";
import Backend from "./backend";
import Userconfig from "./user/";
import Dashboardpage from "./dashboard/";
import Useradmin from "./useradmin/";
import Limitpage from "./limit/";
import Reportpage from "./report/";
import Apikeypage from "./apikey/";
import Apiusagepage from "./apiusage/";
import Summarypage from "./summary/";
import Paymentpage from "./payment/";
import { getuserbyid, CheckToken } from "../../API/Auth";
import { UserContext } from "../../Context/UserContext";
import { getAPIkey } from "../../API/apikey";
import { APIContext } from "../../Context/APIContext";
import { getUserall } from "../../API/User";
import { getService } from "../../API/Service";
import { ServiceContext } from "../../Context/ServiceContext";
import { getUsageSum, getUsageStat } from "../../API/Usage";
import { getPaymentList } from "../../API/paymentApi";
import { getFiberObtic } from "../../API/Fiber";
import { LangContext } from "../../Context/Langcontext";
import { getNotification, getAllNotification } from "../../API/Notification";

const App = ({ match }) => {
  const userContext = useContext(UserContext);
  const apiContext = useContext(APIContext);
  const serviceContext = useContext(ServiceContext);
  const [render, setrender] = useState(false);
  const { history, location } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  React.useEffect(() => {
    document.title = `${
      location.pathname === "/app/api"
        ? lang.Welcome
        : location.pathname === "/app/user/change-password"
        ? lang.ChangePassword
        : location.pathname === "/app/user/billing"
        ? lang.BillingInfo
        : location.pathname.startsWith("/app/useradmin")
        ? lang.User
        : location.pathname.startsWith("/app/limit")
        ? lang.LimitUsage
        : lang[
            `${location.pathname
              .replace("/app/", "")
              .replace("/main", "")
              .charAt(0)
              .toUpperCase()}${location.pathname
              .replace("/app/", "")
              .replace("/main", "")
              .slice(1)}`
          ]
    } | ${lang.MEAtitle}`;
    return () => {};
  }, [lang, location]);

  const route_admin = () => {
    return (
      <Fragment>
        <Route path={`${match.url}/dashboard`} component={Dashboardpage} />
        <Route path={`${match.url}/useradmin`} component={Useradmin} />
        <Route path={`${match.url}/limit`} component={Limitpage} />
        <Route path={`${match.url}/report`} component={Reportpage} />
        <Route path={`${match.url}/user`} component={Userconfig} />
      </Fragment>
    );
  };

  const route_user = () => {
    return (
      <Fragment>
        <Route path={`${match.url}/api`} component={Backend} />
        {/* <Route path={`${match.url}/api`} component={Apikeypage} /> */}
        <Route path={`${match.url}/key`} component={Apikeypage} />
        <Route path={`${match.url}/usage`} component={Apiusagepage} />
        <Route path={`${match.url}/summary`} component={Summarypage} />
        <Route path={`${match.url}/payment`} component={Paymentpage} />
        <Route path={`${match.url}/user`} component={Userconfig} />
      </Fragment>
    );
  };

  const setData = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      const rsCheckAuth = await CheckToken(token);
      if (rsCheckAuth && rsCheckAuth.token) {
        const user = await getuserbyid(localStorage.getItem("uid"));

        const api = await getAPIkey();

        const service = await getService();

        const sum = await getUsageSum();

        const fiber = await getFiberObtic();

        const payment = await getPaymentList();

        let notification;
        if (
          localStorage.getItem("role") === "admin" ||
          localStorage.getItem("role") === "root"
        ) {
          notification = await getAllNotification();
          if (notification.status.code === 200) {
            userContext.setNotification(notification.data);
          } else {
            localStorage.clear();
            history.replace("/user");
          }
        } else {
          notification = await getNotification(localStorage.getItem("uid"));
          if (notification.status.code === 200) {
            userContext.setNotification(notification.data);
          } else {
            localStorage.clear();
            history.replace("/user");
          }
        }

        if (user.status.code === 200) {
          if (user.data[0].role === "admin" || user.data[0].role === "root") {
            const userall = await getUserall();
            const usage = await getUsageStat("/aggregate?group=user_id");

            if (userall.status.code === 200) {
              userContext.setData(userall.data);
              serviceContext.setSum(usage.data);
            } else {
            }
          }

          userContext.setstate({
            ...userContext.state,
            _id: user.data[0]._id,
            email: user.data[0].email,
            first_name: user.data[0].first_name,
            last_name: user.data[0].last_name,
            organization: user.data[0].organization,
            address: user.data[0].address,
            tambon: user.data[0].tambon,
            amphoe: user.data[0].amphoe,
            province: user.data[0].province,
            zipcode: user.data[0].zipcode,
            country: user.data[0].country,
            phone: user.data[0].phone,
            google:
              user.data[0].google !== undefined ? user.data[0].google : null,
            mea: user.data[0].mea !== undefined ? user.data[0].mea : null,
            facebook:
              user.data[0].facebook !== undefined
                ? user.data[0].facebook
                : null,
            contract: {
              start_date:
                user.data[0].contract === undefined
                  ? ""
                  : user.data[0].contract.start_date,
              end_date:
                user.data[0].contract === undefined
                  ? ""
                  : user.data[0].contract.end_date,
            },
            billing_info: {
              first_name:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.first_name,
              last_name:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.last_name,
              organization:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.organization,
              address:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.address,
              tambon:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.tambon,
              amphoe:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.amphoe,
              province:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.province,
              zipcode:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.zipcode,
              country:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.country,
              phone:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.phone,
              tax:
                user.data[0].billing_info === undefined
                  ? ""
                  : user.data[0].billing_info.tax,
            },

            role: user.data[0].role,
            created_at: user.data[0].created_at,
            profile_picture:
              user.data[0].profile_picture !== undefined
                ? user.data[0].profile_picture
                : "",
          });
        } else {
          localStorage.clear();
          history.replace("/user");
        }

        if (api.status.code === 200) {
          for (var i = 0; i < api.data.length; i++) {
            api.data[i].show = true;
          }
          apiContext.setData(api.data);
        } else {
          localStorage.clear();
          history.replace("/user");
        }

        if (service.status.code === 200) {
          serviceContext.setData(service.data);
        } else {
          localStorage.clear();
          history.replace("/user");
        }

        let sum_net = 0;
        if (payment.status.code === 200 && payment.data.length !== 0) {
          userContext.setPayment(payment.data);

          payment.data
            .filter((res) => {
              return res.type === "prepaid";
            })
            .map((rs) => {
              return (sum_net = sum_net + rs.total);
            });
        } else {
        }

        if (fiber.status.code === 200) {
          serviceContext.setFiber(fiber.data);
        } else {
          localStorage.clear();
          history.replace("/user");
        }

        if (sum.status.code === 200) {
          userContext.setSum({
            ...userContext.sum,
            _id: sum.data[0] !== undefined ? sum.data[0]._id : 0,
            sum_cost: sum.data[0] !== undefined ? sum.data[0].sum_cost : 0,
            sum_net: sum.data[0] !== undefined ? sum.data[0].sum_net : 0,
            sum_request:
              sum.data[0] !== undefined ? sum.data[0].sum_request : 0,
            sum_size: sum.data[0] !== undefined ? sum.data[0].sum_size : 0,
            sum_vat: sum.data[0] !== undefined ? sum.data[0].sum_vat : 0,
            balance: Number(
              Number(sum_net) -
                Number(sum.data[0] !== undefined ? sum.data[0].sum_net : 0)
            ),
            fetch: true,
          });
        } else {
          localStorage.clear();
          history.replace("/user");
        }
      } else {
        localStorage.clear();
        history.replace("/user");
      }
    } else {
      localStorage.clear();
      history.replace("/user");
    }
  }, [userContext, apiContext, history, serviceContext]);

  useEffect(() => {
    if (!render) {
      setData();

      setrender(true);
    } else {
    }
  }, [render, setData]);

  return (
    <AppLayout>
      <Switch>
        {localStorage.getItem("role") === "admin" ? (
          <Redirect
            exact
            from={`${match.url}/`}
            to={`${match.url}/dashboard`}
          />
        ) : localStorage.getItem("role") === "root" ? (
          <Redirect
            exact
            from={`${match.url}/`}
            to={`${match.url}/dashboard`}
          />
        ) : (
          <Redirect exact from={`${match.url}/`} to={`${match.url}/api`} />
        )}

        {localStorage.getItem("role") === "admin"
          ? route_admin()
          : localStorage.getItem("role") === "root"
          ? route_admin()
          : route_user()}
        <Redirect to="/error" />
      </Switch>
    </AppLayout>
  );
};

export default App;
